import {
  FocusContext,
  useFocusable,
} from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getImageForType } from "../../utils/cms.utils";
import ContentTag from "../../utils/tag";
import {
  getAgeRangePublicRoute,
  isContentItemAllowedForAgeRange,
} from "../../utils/ageRange.util";
import { useInputMode } from "../../utils/hooks/useInputMode";
import NextPlayGuideHelper from "../../utils/nextPlayGuideHelper";

const MovieItem = ({ item = {}, onFocus, nextPlayGuide }) => {
  const navigate = useNavigate();
  const { contentPhotos, tags, slug, contentType, _id } = item;

  const handleEnterPress = () => {
    const contentKind = contentType?.kind || "movie";
    if (contentKind === "music") {
      navigate(`/${contentKind}/${slug}`, {
        state: NextPlayGuideHelper.withGuideNavigationState(null, nextPlayGuide),
      });
    } else {
      navigate(`/${contentKind}/${slug}`);
    }
  };

  const { focused, ref, focusSelf } = useFocusable({
    onFocus,
    onEnterPress: handleEnterPress,
    focusKey: "content_" + _id,
  });
  const { setMouseFocus } = useInputMode();
  const handleMouseEnter = useCallback(() => {
    setMouseFocus(true);
    focusSelf();
  }, [focusSelf, setMouseFocus]);

  return (
    <div
      ref={ref}
      className="legacy-artist-movie-card"
      onMouseEnter={handleMouseEnter}
      onClick={handleEnterPress}
    >
      <div
        className="legacy-artist-movie-poster"
        style={{
          backgroundImage: `url(${getImageForType("verticalCover", contentPhotos)})`,
        }}
      >
        {tags?.[0] && <ContentTag label={tags?.[0]} />}
        <div
          className={
            "legacy-artist-movie-overlay" + (focused ? " is-visible" : "")
          }
        >
          <div className="legacy-artist-movie-title">
            {item.title}
          </div>
          <div className="legacy-artist-movie-year">
            {item.year}
          </div>
        </div>
      </div>
      <div
        className={
          "legacy-artist-movie-focus" + (focused ? " is-focused" : "")
        }
      />
    </div>
  );
};

export const MoviesSlider = ({
  movies,
  onFocus,
  rowTitle,
  shouldFocusSelf,
  nextPlayGuide,
}) => {
  const ageRange = getAgeRangePublicRoute();
  const _items = movies.filter((x) => isContentItemAllowedForAgeRange(x, ageRange));
  const { ref, focusKey, focusSelf } = useFocusable({ onFocus });

  useEffect(() => {
    if (shouldFocusSelf === true) {
      focusSelf();
    }
  }, [shouldFocusSelf]);

  const scrollingRef = useRef(null);

  const onAssetFocus = useCallback(
    (props) => {
      if (typeof onFocus === "function") onFocus(props);
    },
    [onFocus]
  );
  if (_items.length < 1) return null;
  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className="legacy-row-wrapper legacy-row-wrapper-spaced">
        <div className="legacy-row-title legacy-row-title-right">{rowTitle}</div>
        <div ref={scrollingRef} className="legacy-row-scroller">
          <div className="legacy-row-scroller-content legacy-row-scroller-content-wrap">
            {_items?.map((item) => {
              return (
                <MovieItem
                  item={item}
                  key={item._id}
                  onFocus={onAssetFocus}
                  nextPlayGuide={nextPlayGuide}
                />
              );
            })}
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  );
};
